module.exports = __webpack_public_path__ + "img/user.7cd70546.png";